import * as components from './components'

export default [
  {
    path: '/employer/board',
    component: components.EmployerBoard,
    name: 'employerBoard',
    props: true
  },
  {
    path: '/employer/:uuid/details',
    component: components.EmployerDetails,
    name: 'employerDetails',
    props: true
  }
]



// WEBPACK FOOTER //
// ./src/app/employer/routes.js